import { Link } from 'react-router-dom';

// Matches **bold**, email addresses, URLs, and references to the Privacy Policy.
const INLINE_PATTERN =
  /\*\*(.+?)\*\*|([\w.+-]+@[\w-]+(?:\.[\w-]+)*\.[a-z]{2,})|(https?:\/\/[^\s]*[^\s.,])|(BCA’s Privacy Policy)/gi;

function renderInline(text) {
  const parts = [];
  let last = 0;
  let match;
  INLINE_PATTERN.lastIndex = 0;

  while ((match = INLINE_PATTERN.exec(text)) !== null) {
    if (match.index > last) parts.push(text.slice(last, match.index));
    const [whole, bold, email, url, privacy] = match;
    const key = match.index;

    if (bold) parts.push(<strong key={key}>{bold}</strong>);
    else if (email) parts.push(<a key={key} href={`mailto:${email}`}>{email}</a>);
    else if (url)
      parts.push(
        <a key={key} href={url} target="_blank" rel="noopener noreferrer">
          {url}
        </a>
      );
    else if (privacy) parts.push(<Link key={key} to="/privacy-policy">{privacy}</Link>);
    else parts.push(whole);

    last = match.index + whole.length;
  }

  if (last < text.length) parts.push(text.slice(last));
  return parts;
}

function LegalContent({ blocks }) {
  return blocks.map((block, i) => {
    switch (block.type) {
      case 'title':
        return (
          <h1 key={i} className="section-heading">
            {block.text}
          </h1>
        );
      case 'subtitle':
        return (
          <p key={i} className="legal-subtitle">
            {block.text}
          </p>
        );
      case 'h2':
        return (
          <h2 key={i} id={block.id}>
            {block.number ? `${block.number}. ` : ''}
            {block.text}
          </h2>
        );
      case 'h3':
        return (
          <h3 key={i} id={block.id}>
            {block.text}
          </h3>
        );
      case 'label':
        return (
          <p key={i} className="legal-label">
            {block.text}
          </p>
        );
      case 'ul':
        return (
          <ul key={i}>
            {block.items.map((item, j) => (
              <li key={j}>{renderInline(item)}</li>
            ))}
          </ul>
        );
      default:
        return <p key={i}>{renderInline(block.text)}</p>;
    }
  });
}

export default LegalContent;
